import { FC } from "react";
import { IconPropsType } from ".";

export const Person2: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="13"
      height="20"
      viewBox="0 0 13 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 19.0663C9.28632 19.0663 11.7272 17.4896 12.9368 15.1783C12.6561 11.852 9.89132 9.25995 6.5 9.25995C3.10869 9.25995 0.344002 11.8519 0.0632019 15.1783C1.27276 17.4679 3.71364 19.0663 6.5 19.0663Z"
        fill={props.color ?? "white"}
      />
      <path
        d="M10.1504 4.65917C10.1504 6.93774 8.51609 8.78477 6.49996 8.78477C4.48383 8.78477 2.84952 6.9377 2.84952 4.65917C2.84952 2.38076 4.48383 0.533569 6.49996 0.533569C8.51609 0.533569 10.1504 2.38064 10.1504 4.65917Z"
        fill={props.color ?? "white"}
      />
    </svg>
  );
};
